import React from "react"
import { Row, Col } from "reactstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFacebookF, faXTwitter } from "@fortawesome/free-brands-svg-icons"
import { FacebookShareButton, TwitterShareButton } from "react-share"
import SidebarBlock from "components/shared/SidebarBlock"
import { graphql, useStaticQuery } from "gatsby"

const Sidebar = (props) => {
  const { type, data, shareUrl } = props

  let sidebars = data.acfTwoColumnFlexibleContent?.sidebar || data.template?.acfTwoColumnFlexibleContent.sidebar;
  const options = useStaticQuery(graphql`
    query {
      allWp {
        edges {
          node {
            ...optionsFragment
          }
        }
      }
    }
  `)

  if (type === "News" && !sidebars) {
    // use page sidebars if exist, if not use global sidebars
    sidebars = options.allWp.edges[0]?.node?.options?.acfOptions?.newsGlobalSidebar
  }

  return(
    <>
      {type === "News" &&
      <Col xs={12} className="pb-3 px-lg-0">
          <div className="share">
            <span>SHARE ARTICLE</span>
            <FacebookShareButton className="share-button d-inline-block mr-4" url={shareUrl}>
              <FontAwesomeIcon icon={faFacebookF} />
            </FacebookShareButton>
            <TwitterShareButton className="share-button d-inline-block" url={shareUrl}>
              <FontAwesomeIcon icon={faXTwitter} />
            </TwitterShareButton>
          </div>
        </Col>
      }
      {sidebars &&
        <Col xs={{ size: "auto", order: 2}} md={{ order: 3 }} className="pb-3">
          <Row className="justify-content-center">
            {sidebars.map((node, i) => {
                return(
                  <Col xs={12} sm={6} lg={12} className="pb-3 pb-md-0 px-lg-0" key={i}>
                    <SidebarBlock data={node} margin={true} />
                  </Col>
                )
              })
            }
          </Row>
        </Col>
      }
    </>
  )
}

export default Sidebar